<template>
  <div>
    <ServiceOrderFormCreate />
  </div>
</template>

<script>

import ServiceOrderFormCreate from '@/views/service-order/request/create/ServiceOrderFormCreate'

export default {
  name: 'Create',
  components: { ServiceOrderFormCreate },
}

</script>
